'use client';

import cn from 'classnames';
import Link from 'next/link';
import {
  AnchorHTMLAttributes,
  HTMLAttributes,
  PropsWithChildren,
  ReactNode,
} from 'react';

interface IMobileNavLink extends HTMLAttributes<HTMLDivElement> {
  icon?: ReactNode | null;
  title: string;
  active?: boolean;
  linkProps?: AnchorHTMLAttributes<HTMLAnchorElement>;
}

export const MobileNavLink = ({
  icon,
  title,
  className,
  linkProps,
  active = true,
  ...props
}: IMobileNavLink) => {
  const Wrapper = ({ children }: PropsWithChildren) => {
    if (!linkProps) return <>{children}</>;
    return (
      <Link
        {...linkProps}
        className={cn(linkProps.className, 'contents')}
        href={linkProps.href || '#'}
      >
        {children}
      </Link>
    );
  };

  return (
    <Wrapper>
      <div
        {...props}
        className={cn(
          'flex flex-col items-center duration-300 cursor-pointer select-none',
          !active && 'text-[#B6B6B6] fill-[#B6B6B6]',
          className,
        )}
      >
        <div>{icon}</div>
        <div
          className={
            'text-[13px] min-[380px]:text-[14px] sm:text-[16px] font-light'
          }
        >
          {title}
        </div>
      </div>
    </Wrapper>
  );
};
